const rules = {
  DRIVER: {
    static: [
      '/login',
      '/driver-management'
    ],
  },
  NONE: {
    static: ['/login'],
  },
};

export default rules;
